import React from "react";
import styles from "./style.module.css";

interface Props {
  type: "top" | "bottom";
  children?: React.ReactNode;
}

export default function StickyContent({ type, children }: Props) {
  return (
    <div className={`${type === "top" ? styles.topFix : styles.bottomFix}`}>
      {children}
    </div>
  );
}
